module.exports = __webpack_public_path__ + "img/uploadresumemain.b3cb93e1.svg";